import { useState, useEffect } from 'react';

const useRegistrationConditionFieldShowValidation = (
  values,
  customFieldList,
) => {
  const [customFields, setCustomFields] = useState([]);

  const getFilteredConditionalFieldsAccordingToLogic = (
    formValues,
    registrationCustomFieldList,
  ) => {
    let formData = formValues && JSON.parse(JSON.stringify(formValues));

    //filteredFields : this is the final list which contains all teh fields that need to be shown after the conditions met.
    let filteredFields = [] as any;
    registrationCustomFieldList &&
      registrationCustomFieldList.map(field => {
        if (field.customFieldConditions.length === 0) {
          filteredFields.push(field);
        } else if (
          field.customFieldConditions &&
          field.customFieldConditions?.length > 0
        ) {
          //Single Logic condition added for a field to show/hide
          if (field.customFieldConditions.length == 1) {
            let fieldLogic = field.customFieldConditions[0];
            let fieldDetails =
              registrationCustomFieldList.filter(
                field =>
                  field.registrationCustomFieldId ===
                  fieldLogic.conditionCustomFieldId,
              )[0] || {};
            //formData : values added by the user
            //fieldDetails.labelName : labelName defined in the orgSide
            if (formData) {
              let fieldValue = formData[fieldDetails.labelName];
              if (
                fieldDetails.fieldType === 'SHORTANSWER' ||
                fieldDetails.fieldType === 'DATE'
              ) {
                if (fieldLogic.fieldConditionType === 'IS_NOT_ANSWERED') {
                  if (!fieldValue || fieldValue.trim() === '') {
                    filteredFields.push(field);
                  }
                }
              }
              if (fieldValue) {
                //checking verifyField for nested conditions scenarios
                //A -> B -> C -> D (if B is removed C gets disappeared but C’s data still exist(if value already entered) so D is still shown)
                let verifyField = filteredFields.filter(
                  field =>
                    field.registrationCustomFieldId ===
                    fieldDetails.registrationCustomFieldId,
                )[0];
                if (!verifyField) {
                  return;
                }
                if (
                  fieldDetails.fieldType === 'SHORTANSWER' ||
                  fieldDetails.fieldType === 'DATE'
                ) {
                  if (fieldLogic.fieldConditionType === 'IS_ANSWERED') {
                    if (fieldValue && fieldValue.trim() !== '') {
                      filteredFields.push(field);
                    }
                  }
                } else if (fieldDetails.fieldType === 'DROPDOWN') {
                  //Checking value key here to identify whether the value entered is comma separated (CSV upload) / object (label, value pair)
                  let dropDownFieldValue = formData[fieldDetails.labelName];
                  if (JSON.stringify(dropDownFieldValue).includes('value')) {
                    dropDownFieldValue = dropDownFieldValue.value.trim();
                  }
                  if (fieldLogic.fieldConditionType === 'IS') {
                    if (
                      fieldLogic.compareOptions.includes(
                        dropDownFieldValue.trim(),
                      )
                    ) {
                      filteredFields.push(field);
                    }
                  } else if (fieldLogic.fieldConditionType === 'IS_NOT') {
                    if (
                      !fieldLogic.compareOptions.includes(
                        dropDownFieldValue.trim(),
                      )
                    ) {
                      filteredFields.push(field);
                    }
                  }
                } else if (fieldDetails.fieldType === 'MULTISELECT') {
                  let selectedOptions = new Array();
                  let multiselectFieldValue = formData[fieldDetails.labelName];
                  //Checking value key here to identify whether the value entered is comma separated (CSV upload) / object (label, value pair)
                  //If value is comma separated then converting it to array of string using split(',')
                  if (
                    !JSON.stringify(multiselectFieldValue).includes('value')
                  ) {
                    selectedOptions =
                      multiselectFieldValue?.length > 0 &&
                      multiselectFieldValue.split(',');
                  } else {
                    selectedOptions = multiselectFieldValue;
                  }
                  if (fieldLogic.fieldConditionType === 'ALL_OFF') {
                    //compareOptionsList : List which is defined in orgSide for conditions logic
                    //selectedOptions : List which is selected by the attendee
                    let allValuesMatched = true;
                    if (!selectedOptions) {
                      allValuesMatched = false;
                    }
                    let compareOptionsList = fieldLogic.compareOptions.split(
                      ',',
                    );
                    selectedOptions &&
                      compareOptionsList.forEach(element => {
                        if (
                          !JSON.stringify(selectedOptions).includes(
                            element.trim(),
                          )
                        ) {
                          allValuesMatched = false;
                        }
                      });
                    if (allValuesMatched) {
                      filteredFields.push(field);
                    }
                  } else if (fieldLogic.fieldConditionType === 'ANY_OFF') {
                    //compareOptionsList : List which is defined in orgSide for conditions logic
                    //selectedOptions : List which is selected by the attendee
                    let anyValueMatched = false;
                    if (!selectedOptions) {
                      anyValueMatched = false;
                    }
                    let compareOptionsList = fieldLogic.compareOptions.split(
                      ',',
                    );
                    selectedOptions &&
                      compareOptionsList.forEach(element => {
                        if (
                          JSON.stringify(selectedOptions).includes(
                            element.trim(),
                          )
                        ) {
                          anyValueMatched = true;
                        }
                      });
                    if (anyValueMatched) {
                      filteredFields.push(field);
                    }
                  }
                }
              }
            }
          } else if (field.customFieldConditions.length > 1) {
            //Multiple logic condition added for a field to show/hide
            //showField : this key is by default true, will change to false when any one condition is not satisfied (AND condition)
            let showField = true;
            field.customFieldConditions.map(fieldLogic => {
              let fieldDetails =
                registrationCustomFieldList.filter(
                  field =>
                    field.registrationCustomFieldId ===
                    fieldLogic.conditionCustomFieldId,
                )[0] || {};

              //In case of Multiple logic for single field to show (AND scenario)
              //if any one case if false no need to check other fields conditions
              if (!showField) {
                return;
              }
              //formData : values added by the user
              //fieldDetails.labelName : labelName defined in the orgSide
              if (formData) {
                //This is to check/validate condition after field/key is entered, validate answer
                let fieldValue = formData[fieldDetails.labelName];
                if (
                  fieldDetails.fieldType === 'SHORTANSWER' ||
                  fieldDetails.fieldType === 'DATE'
                ) {
                  if (fieldLogic.fieldConditionType === 'IS_NOT_ANSWERED') {
                    if (fieldValue && fieldValue.trim() !== '') {
                      showField = false;
                    }
                  }
                }
                if (fieldValue) {
                  //checking verifyField for nested conditions scenarios
                  //A -> B -> C -> D (if B is removed C gets disappeared but C’s data still exist(if value already entered) so D is still shown)
                  let verifyField = filteredFields.filter(
                    field =>
                      field.registrationCustomFieldId ===
                      fieldDetails.registrationCustomFieldId,
                  )[0];
                  let nestedFieldValid = true;
                  if (!verifyField) {
                    showField = false;
                    nestedFieldValid = false;
                  }
                  if (
                    fieldDetails.fieldType === 'SHORTANSWER' ||
                    fieldDetails.fieldType === 'DATE'
                  ) {
                    if (fieldLogic.fieldConditionType === 'IS_ANSWERED') {
                      if (!fieldValue || fieldValue.trim() === '') {
                        showField = false;
                      }
                    }
                  } else if (fieldDetails.fieldType === 'DROPDOWN') {
                    //Checking value key here to identify whether the value entered is comma separated (CSV upload) / object (label, value pair)
                    let dropDownFieldValue = formData[fieldDetails.labelName];
                    if (JSON.stringify(dropDownFieldValue).includes('value')) {
                      dropDownFieldValue = dropDownFieldValue.value.trim();
                    }
                    if (fieldLogic.fieldConditionType === 'IS') {
                      if (
                        !fieldLogic.compareOptions
                          .trim()
                          .includes(dropDownFieldValue.trim())
                      ) {
                        showField = false;
                      }
                    } else if (fieldLogic.fieldConditionType === 'IS_NOT') {
                      if (
                        fieldLogic.compareOptions.includes(
                          dropDownFieldValue.trim(),
                        )
                      ) {
                        showField = false;
                      }
                    }
                  } else if (fieldDetails.fieldType === 'MULTISELECT') {
                    //Checking value key here to identify whether the value entered is comma separated (CSV upload) / object (label, value pair)
                    //If value is comma separated then converting it to array of string using split(',')
                    let selectedOptions = new Array();
                    if (!JSON.stringify(fieldValue).includes('value')) {
                      selectedOptions =
                        fieldValue?.length > 0 && fieldValue.split(',');
                    } else {
                      selectedOptions = fieldValue;
                    }
                    //compareOptionsList : List which is defined in orgSide for conditions logic
                    //selectedOptions : List which is selected by the attendee
                    if (fieldLogic.fieldConditionType === 'ALL_OFF') {
                      let compareOptionsList = fieldLogic.compareOptions.split(
                        ',',
                      );
                      //This condition is to hide the fields when canceled all the selected multiselect options
                      //selectedOptions will be false here in this case
                      if (!selectedOptions) {
                        showField = false;
                      }
                      selectedOptions &&
                        compareOptionsList.forEach(element => {
                          if (
                            !JSON.stringify(selectedOptions).includes(
                              element.trim(),
                            )
                          ) {
                            showField = false;
                          }
                        });
                    } else if (fieldLogic.fieldConditionType === 'ANY_OFF') {
                      let valueMatched = false;
                      let compareOptionsList = fieldLogic.compareOptions.split(
                        ',',
                      );
                      selectedOptions &&
                        compareOptionsList.forEach(element => {
                          if (
                            JSON.stringify(selectedOptions).includes(
                              element.trim(),
                            )
                          ) {
                            valueMatched = true;
                          }
                        });
                      showField = nestedFieldValid && valueMatched;
                    }
                  }
                } else {
                  //This is to check/validate condition before field/key is entered
                  //This will be check if the label itself is not defined / not found in the values object entered by user
                  if (
                    fieldDetails.fieldType === 'SHORTANSWER' ||
                    fieldDetails.fieldType === 'DATE'
                  ) {
                    if (fieldLogic.fieldConditionType === 'IS_NOT_ANSWERED') {
                      if (fieldValue && fieldValue.trim() !== '') {
                        showField = false;
                      }
                    } else {
                      showField = false;
                    }
                  } else {
                    showField = false;
                  }
                }
              } else {
                showField = false;
              }
            });
            if (showField) {
              filteredFields.push(field);
            }
          }
        }
      });
    setCustomFields(filteredFields);
    return filteredFields;
  };

  useEffect(() => {
    if (!customFieldList) {
      return;
    }
    getFilteredConditionalFieldsAccordingToLogic(values, customFieldList);
  }, [customFieldList, values]);

  return { customFields, getFilteredConditionalFieldsAccordingToLogic };
};

export default useRegistrationConditionFieldShowValidation;
